import { styled, TextField, Typography } from '@mui/material';
import { colors } from 'assets/styles/AMBGTheme';

export const StyledInputLabel = styled(Typography)({
	fontSize: '12px',
	fontWeight: '500',
	color: colors.black.shade2,
	marginBottom: '8px'
}) as typeof Typography;

export const StyledTextInput = styled(TextField)((props) => ({
	'& .MuiInputBase-root': {
		fontSize: '12px',
		borderRadius: '24px'
	},

	'& .MuiInputBase-input': {
		paddingTop: props.size === 'small' && '11.5px',
		paddingBottom: props.size === 'small' && '11.5px'
	}
})) as typeof TextField;
